import requestReducerFactory from './requestReducerFactory';
import { ErrorType, LoadedType, RequestType } from '../actions/automations';

export default requestReducerFactory(RequestType, LoadedType, ErrorType);
